// extracted by mini-css-extract-plugin
export default {"container":"RepositoryDetails_container__FBH4B","header":"RepositoryDetails_header__4AyG3"};